import React, { useEffect, useState } from "react";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import FieldElements from "../UniversalComponents/FieldElements";
import ButtonGroup from "../UniversalComponents/ButtonGroup";
import CloseIcon from "../../assets/images/icons/CloseModal1.svg";
import EditIcon from "../../assets/images/disableImg.svg";
import {
  useFetchAllTaskPodsQuery,
  useFetchCustomerTaskPodAllCustomerDataQuery,
  useFetchSingleProjectQuery,
  useLazyGetProjectTaskEnumQuery,
} from "../../utils/customer/customerTaskTable";
import { useCreateUpdateProjectsMutation } from "../../utils/customer/customerSelect";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import { Field } from "formik";
import TaskFormValidation from "../../hooks/ErrorHandling/TaskFormValidation";
import { parseJsonValues } from "../../utils/utilityFunctions/stringUtility";

const validationRules = {
  customer_id: {
    required: true,
    errorMessage: "Customer Name is required.",
    compulsory: true,
  },
  project_name: {
    required: true,
    errorMessage: "Project Name is required.",
    compulsory: true,
  },
};
const generateTaxYears = (startYear = 2020, endYear = 2035) => {
  return Array.from({ length: endYear - startYear + 1 }, (_, index) => ({
    label: `${startYear + index}`,
    value: `${startYear + index}`,
  }));
};

const taxYears = generateTaxYears();
const monthsList = [
  { label: "January", value: "January" },
  { label: "February", value: "February" },
  { label: "March", value: "March" },
  { label: "April", value: "April" },
  { label: "May", value: "May" },
  { label: "June", value: "June" },
  { label: "July", value: "July" },
  { label: "August", value: "August" },
  { label: "September", value: "September" },
  { label: "October", value: "October" },
  { label: "November", value: "November" },
  { label: "December", value: "December" },
];

const AddViewProjectDrawer = ({
  open,
  setOpen,
  onClose,
  taskid,
  setJobFormData,
  handleClickItem = () => {},
  customerTaskPodAllCustomer,
  projectId,
  getFieldValue,
  projectFieldList,
  fetchPersonInTable,
  personTableData,
  selectedCustomer,
  refetch,
  customerTask,
  refetchGetAllTasks = () => {},
}) => {
  const [isFormDisabled, setIsFormDisabled] = useState(false);
  const initialFormData = {
    customer_id: selectedCustomer?.id,
  };

  const [formData, setFormData] = useState(initialFormData);
  const dispatch = useDispatch();
  const { data: newTaskpodsAll, refetch: refetchAllTaskpods } = useFetchAllTaskPodsQuery({
    type: "task",
    customerId: formData?.customer_id ?? "",
  });

  const { values, errors, touched, handleChange, handleBlur, validateField, isFormValid } = TaskFormValidation(
    formData,
    validationRules
  );
  const {
    data: projectDetailsData,
    isFetching,
    refetch: refetchSingleProject,
  } = useFetchSingleProjectQuery({
    projectId: open !== "add" ? projectId : "",
  });

  useEffect(() => {
    if (projectDetailsData?.data?.project_name) {
      setFormData(parseJsonValues(projectDetailsData?.data) || {});
    }
  }, [projectDetailsData]);

  // useEffect(() => {
  //   if (isFetching) {
  //     dispatch(showLoader());
  //   } else {
  //     dispatch(hideLoader());
  //   }
  // }, [isFetching]);

  const [createUpdateProject, { data: response, isFetching: isCreatingUpdatingProjectLoading }] =
    useCreateUpdateProjectsMutation();
  const handleInputChange = (e) => {
    // e.preventDefault();
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const projectFields1 = [
    // {
    //   id: "project_review_manager",
    //   name: "project_review_manager",
    //   label: "Review Manager",
    //   type: "select",
    //   value: formData?.project_review_manager,
    //   disabled: true,
    //   apiCall: fetchPersonData,
    //   defaultOptions: personTableData?.map((eachItem) => ({ label: eachItem.name, value: eachItem.email })),
    // },

    {
      id: "customer_id",
      name: "customer_id",
      label: "Customer",
      type: "select",
      isMandatory: true,
      value: formData?.customer_id,
      disabled: Boolean(selectedCustomer?.id),
      defaultOptions: customerTaskPodAllCustomer?.data?.customers.map((item) => ({
        label: item.customer_name,
        value: item.customer_id,
      })),
      hide: customerTask, // customer field to hide into customer level
    },
    {
      id: "customer_name",
      name: "customer_name",
      label: "Customer",
      type: "select",
      isMandatory: true,
      value: formData?.customer_name,
      disabled: Boolean(selectedCustomer?.id),
      defaultOptions: customerTaskPodAllCustomer?.data?.customers.map((item) => ({
        label: item.customer_name,
        value: item.customer_id,
      })),
      hide: open !== "view",
    },

    {
      id: "project_name",
      name: "project_name",
      label: "Project Name",
      type: "text",
      value: formData?.project_name,
      isMandatory: true,
      // disabled: true,
    },
    {
      id: "contact_name",
      name: "contact_name",
      label: "Contact Name",
      type: "text",
      value: formData?.contact_name,
      //   disabled: true,
    },

    // {
    //   id: "link_to_project_pod",
    //   name: "link_to_project_pod",
    //   label: "Link to Project Pod",
    //   type: "select",
    //   value: formData?.link_to_project_pod,
    //   // disabled: true,
    //   defaultOptions: newTaskpodsAll?.data?.pods?.map((item) => ({ label: item.pod_name, value: item.pod_name })),
    // },
    // {
    //   id: "legal_entity",
    //   name: "legal_entity",
    //   label: "Legal Entity",
    //   type: "text",
    //   value: formData?.legal_entity,
    //   // disabled: true,
    // },
    // {
    //   id: "gfpo_company",
    //   name: "gfpo_company",
    //   label: "GFPO Company",
    //   type: "text",
    //   value: formData?.gfpo_company,
    //   // disabled: true,
    // },
    // {
    //   id: "project_attachments",
    //   name: "project_attachments",
    //   label: "Attachments",
    //   type: "file",
    //   value: formData?.project_attachments,
    //   disabled: true,
    // },

    // {
    //   id: "software",
    //   name: "software",
    //   label: "Software",
    //   type: "select",
    //   value: formData?.software,
    //   // disabled: true,
    //   apiCall: function () {
    //     return getFieldValue("software");
    //   },
    //   dynamicOptions: projectFieldList?.data?.map((eachItem) => ({ label: eachItem, value: eachItem })),
    // },
    // {
    //   id: "tax_year_end",
    //   name: "tax_year_end",
    //   label: "Tax Year End",
    //   type: "select",
    //   value: formData?.tax_year_end,
    //   // disabled: true,
    //   // apiCall: function () {
    //   //   return getFieldValue("tax_year_end");
    //   // },
    //   // dynamicOptions: projectFieldList?.data?.map((eachItem) => ({ label: eachItem.label, value: eachItem.value })),
    //   defaultOptions: taxYears,
    // },
    // {
    //   id: "annual_accounts_month",
    //   name: "annual_accounts_month",
    //   label: "Annual Accounts Month",
    //   type: "select",
    //   value: formData?.annual_accounts_month,
    //   // disabled: true,
    //   defaultOptions: monthsList,
    // },
    {
      id: "project_partner",
      name: "project_partner",
      label: "Partner",
      type: "select",
      value: formData?.project_partner,
      displayName: formData?.project_partner?.name,
      // disabled: true,
      apiCall: fetchPersonInTable,
      dynamicOptions: personTableData?.data?.map((eachItem) => ({ label: eachItem.name, value: eachItem })),
    },
    {
      id: "manager_reviewer",
      name: "manager_reviewer",
      label: "Manager/Reviewer",
      type: "select",
      value: formData?.manager_reviewer,
      displayName: formData?.manager_reviewer?.name,

      apiCall: fetchPersonInTable,
      dynamicOptions: personTableData?.data?.map((eachItem) => ({ label: eachItem.name, value: eachItem })),
    },
    // {
    //   id: "project_status",
    //   name: "project_status",
    //   label: "Status",
    //   type: "select",
    //   value: formData?.project_status,
    //   // disabled: true,
    //   apiCall: function () {
    //     return getFieldValue("project_status");
    //   },
    //   dynamicOptions: projectFieldList?.data?.map((eachItem) => ({ label: eachItem, value: eachItem })),
    // },
  ];
  const getProjectFields = ({ selectionList, projectFields }) => (
    <>
      {projectFields
        ?.filter((item) => !item?.hide)
        ?.map((eachField) => (
          <div className={`basis-5/5 mb-1 col-span-${eachField.colspan ?? "1"}`}>
            <label htmlFor="project_review_manager" className="block mb-1 text-lg text-434852">
              <span className={`text-sm ${isFormDisabled ? "text-6B6B6B" : "text-434852"}`}>{eachField?.label}</span>
              {eachField?.isMandatory && <span className="text-red-700"> *</span>}
            </label>
            <div className="flex items-center justify-end">
              <FieldElements
                id={eachField?.id}
                name={eachField?.name}
                value={formData[eachField?.name]}
                displayName={eachField?.displayName}
                label={eachField?.label}
                onChange={handleInputChange}
                disabled={eachField?.disabled}
                isFormDisabled={isFormDisabled}
                // defaultOptions={selectionList}
                type={eachField?.type}
                onClick={() => {
                  eachField?.type === "select" && handleClickItem(eachField?.name);
                }}
                formData={formData}
                taskid={taskid}
                defaultOptions={eachField?.defaultOptions}
                dynamicOptions={eachField?.dynamicOptions}
                apiCall={eachField?.apiCall}
                setFormData={setFormData}
                hide={eachField?.hide}
              />
              {/* {getFieldElements(
             { id:eachField?.id,name:eachField?.name,label:eachField?.label,onChange:handleInputChange,disabled:eachField?.disabled,isFormDisabled:eachField?.isFormDisabled,selectionList,type:eachField?.type}
           )} */}
            </div>
          </div>
        ))}
    </>
  );

  const viewProjectFields = ({ ProjectDetails }) => {
    return (
      <>
        {ProjectDetails?.filter((item) => !item?.hide)?.map((eachField) => (
          <div>
            <div className="text-[#848687] text-sm font-300">{eachField?.label}</div>
            <div className="text-[#2C495D] text-sm font-400">{eachField?.displayName ?? eachField?.value ?? "--"}</div>
          </div>
        ))}
      </>
    );
  };

  // useEffect(() => {
  //   if (isCreatingUpdatingProjectLoading) {
  //     dispatch(showLoader());
  //   } else {
  //     dispatch(hideLoader());
  //   }
  // }, [isCreatingUpdatingProjectLoading]);

  const getHasError = (errors) => {
    let hasErrors = false;
    hasErrors = Object.keys(validationRules).some(
      (eachKey) => validationRules[eachKey]?.compulsory && errors[eachKey]?.[0]
    );
    return hasErrors;
  };

  const handleCreateUpdateProject = async () => {
    const formValid = isFormValid();
    const a = getHasError(formValid);

    if (a) {
      dispatch(pushAlert({ message: "Enter Mandatory Fields.", type: "danger", visible: true }));
      return;
    }
    const payload = {
      ...formData,
      start_date: "2024-07-01",
    };

    const result = await createUpdateProject({ payload }).unwrap();
    if (result?.success) {
      dispatch(pushAlert({ message: result?.message, type: "success", visible: true }));
      refetchGetAllTasks();
      if (!projectId) {
        setJobFormData((prevFormData) => ({
          ...prevFormData,
          project_id: result?.data?.id ?? "1",
          project_name: result?.data?.project_name ?? "",
        }));
      }
      if (refetch) {
        refetch();
      } else {
        refetchSingleProject();
      }

      onClose();
    } else {
      // dispatch(pushAlert({ message: result?.message, type: "danger", visible: true }));
      // setJobFormData((prevFormData) => ({
      //   ...prevFormData,
      //   project_id: result?.data?.project_id || "1",
      // }));
      // onClose();
    }
  };

  return (
    <CustomDrawer parallel open={open} onClose={onClose}>
      <div className="flex flex-col h-full">
        <div className="border-b border-[#BECBD3] p-3 px-4 flex justify-between items-center w-full ">
          <div className="text-[#131313CC] text-base font-500">
            <span className="capitalize">{open === "edit" ? `${formData?.customer_name}` : "Add Project"}</span>
          </div>
          <div className="flex gap-4">
            {open === "view" && (
              <button onClick={() => setOpen("edit")}>
                <img className="w-3.5 h-3.5 cursor-pointer" src={EditIcon} />
              </button>
            )}
            <img className="w-3.5 h-3.5 cursor-pointer" src={CloseIcon} onClick={onClose} />
          </div>
        </div>
        <div className="py-2 px-4 grow min-h-0 overflow-auto">
          {["add", "edit"].includes(open) &&
            getProjectFields({
              selectionList: [],
              projectFields: projectFields1,
            })}
          {open === "view" && (
            <div className="border border-[#D2DAE1] rounded-md p-5 flex flex-col gap-y-3">
              {viewProjectFields({
                ProjectDetails: projectFields1,
              })}
            </div>
          )}
        </div>
        {getHasError(errors) && (
          <div className="basis-5/5 flex items-center py-2 px-3 col-span-3">
            <span className="text-red-700">* Enter Mandatory Field</span>
          </div>
        )}
        {["add", "edit"].includes(open) && (
          <div className="p-3 px-4 flex justify-end">
            <ButtonGroup
              primaryText={open === "add" ? "Save" : "Update"}
              primaryClick={handleCreateUpdateProject}
              secondaryClick={onClose}
              secondaryText={"Cancel"}
              primaryType={"button"}
              secondaryType={"button"}
            />
          </div>
        )}
      </div>
    </CustomDrawer>
  );
};

export default AddViewProjectDrawer;
